// LuckyDrawSetup.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function LuckyDrawSetup() {
    const [fraTall, setFraTall] = useState(1);
    const [tilTall, setTilTall] = useState(100);
    const [utelukk, setUtelukk] = useState("");
    const navigate = useNavigate();

    const startTrekning = () => {
        const utelukkListe = utelukk
            .split(",")
            .map(num => parseInt(num.trim(), 10))
            .filter(num => !isNaN(num));
 
            navigate("/luckydrawWindow", {
                state: { fraTall, tilTall, utelukkListe }
            });
            
    };

    return (
        <div className="flex flex-col justify-center items-center h-screen bg-gray-100 text-black">
            <div className="bg-white rounded-lg p-6 text-center shadow-lg w-96">
                <h1 className="text-2xl font-bold mb-4">Velg tallområde</h1>
                <div className="mb-4">
                    <label className="block text-lg">Fra:</label>
                    <input
                        type="number"
                        value={fraTall}
                        onChange={e => setFraTall(parseInt(e.target.value, 10))}
                        className="w-full p-2 border rounded"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-lg">Til:</label>
                    <input
                        type="number"
                        value={tilTall}
                        onChange={e => setTilTall(parseInt(e.target.value, 10))}
                        className="w-full p-2 border rounded"
                    />
                </div>
                <div className="mb-4">
                    <label className="block text-lg">Utelukk tall (kommaseparert):</label>
                    <input
                        type="text"
                        value={utelukk}
                        onChange={e => setUtelukk(e.target.value)}
                        className="w-full p-2 border rounded"
                        placeholder="F.eks. 3, 15, 22"
                    />
                </div>
                <button
                    onClick={startTrekning}
                    className="px-6 py-3 bg-blue-500 text-white font-bold rounded-lg shadow-md hover:bg-blue-600 transition duration-300"
                >
                    Bekreft og start trekning
                </button>
            </div>
        </div>
    );
}

export default LuckyDrawSetup;
